import React, {Component} from "react";
import PropTypes from 'prop-types';
import moment from 'moment';
import ReactHighcharts from 'react-highcharts';
import api from '../../utils/api';
import placeholder from '../../assets/videoImgs/thumbshot1.jpg';
import {Link} from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import PieChart from 'react-minimal-pie-chart';
import { RSA_NO_PADDING } from "constants";

class MyTests extends Component {
    
    constructor(props){
        super(props);
        this.state = {
            expanded: [],
            testDetails: null,
            chart: [],
            chartX: []
        }
    }
    
    componentDidMount(){
        if(this.state.chart.length === 0){
            if(this.props.match.params.view === 'review'){
                this.buildChart('review');
                let cu = this.props.courseUser[0];
                let us = this.props.userSubject;
                if(this.props.courseUser[0].id && this.props.course){
                    if(this.props.course.CourseSubject.filter(s => s.type === "review").length > 0 && !us.id){
                        // console.log("Getting us because no id")
                        this.props.getUserSubject(this.props.courseUser[0].profileId, this.props.course.CourseSubject.filter(s => s.type === "review").id, this.props.courseUser[0].courseId, this.props.user.id);
                    }else if(us.id){
                        // console.log("us has id");
                        // console.log("Review id:", this.props.course.CourseSubject.filter(s => s.type === "review")[0].id, us.Subject.id)
                        if(this.props.course.CourseSubject.filter(s => s.type === "review")[0].id !== us.Subject.id && this.props.courseUser[0].currentSubject === this.props.course.CourseSubject.filter(s => s.type === "review")[0].id){
                            // console.log("have everything i need to get us");
                            this.props.getUserSubject(this.props.courseUser[0].profileId, this.props.course.CourseSubject.filter(s => s.type === "review")[0].id, this.props.courseUser[0].courseId, this.props.user.id);
                        }
                    }
                }
            }else{
                this.buildChart('');
            }
        }

        
        
        
        this.props.onLoad(this.props.user.user.Profile.id, null, this.props.user.id);
        if(this.props.courseUser[0].id){
            this.props.getUserContent(this.props.courseUser[0].profileId, this.props.courseUser[0].courseId, this.props.courseUser[0].id, this.props.user.id);
        }
    }

    componentDidUpdate(props){
        if(props.courseUser[0] !== this.props.courseUser[0]){
            this.props.getUserContent(this.props.courseUser[0].profileId, this.props.courseUser[0].courseId, this.props.courseUser[0].id, this.props.user.id);
        }
        if(props.match.params.view !== 'review' && this.props.match.params.view === 'review'){
            let cu = this.props.courseUser[0];
            let us = this.props.userSubject;
            if(this.props.courseUser[0].id && this.props.course){
                if(this.props.course.CourseSubject.filter(s => s.type === "review").length > 0 && !us.id){
                    // console.log("Getting us because no id")
                    this.props.getUserSubject(this.props.courseUser[0].profileId, this.props.course.CourseSubject.filter(s => s.type === "review").id, this.props.courseUser[0].courseId, this.props.user.id);
                }else if(us.id){
                    // console.log("us has id");
                    // console.log("Review id:", this.props.course.CourseSubject.filter(s => s.type === "review")[0].id, us.Subject.id)
                    if(this.props.course.CourseSubject.filter(s => s.type === "review")[0].id !== us.Subject.id && this.props.courseUser[0].currentSubject === this.props.course.CourseSubject.filter(s => s.type === "review")[0].id){
                        // console.log("have everything i need to get us");
                        this.props.getUserSubject(this.props.courseUser[0].profileId, this.props.course.CourseSubject.filter(s => s.type === "review")[0].id, this.props.courseUser[0].courseId, this.props.user.id);
                    }
                }
            }
        }

       
    }

    renderHeader = () => {
        return (
            <div className="bg-light lter b-b wrapper-md">
                <div className="row">
                    <div className="col-sm12 col-xs-12">
                        <h1 className="m-n font-thin h3 text-black">My Tests | All Tests</h1>
                        <small className="text-muted">Monitor your progress, review your results, and retake tests</small>
    
                    </div>
                </div>
            </div>    
        )
    }
    
    renderTabs = () => {
        return (
            <div className="setting-header-nav">
                <ul className="header-nav">
                    <li className={!this.props.match.params.view ? "active" : ""}><Link to="/my-tests">All Tests</Link> </li>
                    <li className={this.props.match.params.view === "review" ? "active" : ""}><Link to="/my-tests/review">Review</Link> </li>
                    <li className={!this.props.match.params.view === "purchases" ? "active" : ""}><Link to="/my-tests/purchases">My Purchases</Link> </li>
                </ul>
            </div>    
        )
    }

    renderQuizModal = () => {
        let options = ['0', 'A', 'B', 'C', 'D', 'E'];
        return (
            <div tabIndex="-1" className="modal fade" id="QuizResultModal" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                <Scrollbars style={{ height: "calc(100vh - 100px)" }}>
                    <div className="modal-content light-text test-result-modal">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Quiz Summary</h4>
                        </div>
                        <div className="modal-body">
                        {this.props.quizDetails ? 
                            this.props.quizDetails.id ?
                        <div className="FinalAnswerToMCQ sp-20">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <p className="font-30 font-300 sm-bottom30">Quiz Results</p>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <p className="no-margin">Correct</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.props.quizDetails.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                    <p className="no-margin">Incorrect</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.props.quizDetails.totalQuestions - this.props.quizDetails.correctAnswers}</p>
                                </div>
                                {this.props.quizDetails.timeLimit ?
                                    <div className="col-sm-3">
                                        <p className="no-margin">Time Taken</p>
                                        <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">
                                            {this.props.quizDetails.timeLimit - this.props.quizDetails.completedIn > 0 ?
                                                moment.utc(moment.duration((this.props.quizDetails.completedIn) * 1000).as('milliseconds')).format('HH:mm:ss')
                                            : '00:00'}
                                        </p>
                                    </div>
                                :
                                <div className="col-sm-3">
                                </div>
                                }


                                <div className="col-sm-3">
                                    <div className="video-question-summary">
                                        <PieChart
                                            style={{width: 80, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#555'},
                                                {value: this.props.quizDetails.correctPercent, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.props.quizDetails.correctPercent}%</p>
                                    </div>

                                    </div>
                            </div>
                            <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                                {this.props.quizDetails.correctPercent >= 80 ?
                                <span className="text-success"> {this.props.quizDetails.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                                    :
                                    <span className="text-danger"> Failed</span>}

                                    </p>

                            <table className="table">
                                <tbody>
                                <tr>
                                    <th className="text-center" style={{width: 50}}>Result</th>
                                    <th className="text-center" style={{width: 100}}>Answered</th>
                                    <th className="text-left">Question</th>
                                    <th className="text-center" style={{width: 122}}>Time Taken</th>
                                </tr>
                                {this.props.quizDetails.answers.map((a, i) => {
                                        let seconds = 0;
                                        let timer = "";
                                        if(a.time){
                                            seconds = parseInt(a.time % 60);
                                            timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                                : parseInt(a.time / 60) + ":" + seconds.toString();
                                        }
                                        return (
                                            <tr key={i}>
                                                <td className="text-center"><i className={(a.correct) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                                <td className="text-center">
                                                    {options[a.answer]}
                                                </td>
                                                <td className="text-left">
                                                    <p className="font-14" data-toggle="collapse" data-target={`#LECTUREQUIZ-${i}`} aria-expanded="false" aria-controls={`#LECTUREQUIZ-${i}`} dangerouslySetInnerHTML={{__html: a.quizQuestionId.question}}></p>
                                                    <div className="modalQuizeAnswersOptions collapse" id={`LECTUREQUIZ-${i}`}>
                                                                    {options.filter(o => o !== '0').map((o, oi) => {
                                                                        if(o === "E"){
                                                                            return (
                                                                                <div className="modalQuizeAnswers" key={oi}>
                                                                                    <div class={`AnsOption ${a.answer === options.indexOf(o) ? a.answer === a.quizQuestionId.correctOption ? 'bg-success' : 'bg-danger' : ''}`}>{o}</div>
                                                                                    <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                                </div>
                                                                            )
                                                                        }else{
                                                                            return (
                                                                                <div className="modalQuizeAnswers" key={oi}>
                                                                                    <div class={`AnsOption ${a.answer === options.indexOf(o) ? a.answer === a.quizQuestionId.correctOption ? 'bg-success' : 'bg-danger' : ''}`}>{o}</div>
                                                                                    <div className="AnsText" dangerouslySetInnerHTML={{__html: a.quizQuestionId["option" + o]}}></div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                        
                                                                    })}
                                                                    
                                                                </div>
                                                </td>
                                                <td className="text-center">{timer}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                        : null
                        : null }
                        </div>

                    </div>
                    </Scrollbars>
                </div>
                    
                </div>
        )
    }
    
    renderTests = () => {
        let cu = this.props.courseUser[0];
        let tests = [];
        let isReview = this.props.match.params.view === 'review';
        let rsid = 'review';
        if(this.props.testCourse.CourseSubject){
            this.props.testCourse.CourseSubject.map(s => {
                if(s.type === "review"){
                    rsid = s.id;
                }
                if((s.type === "review" && this.props.match.params.view === 'review') || (!s.type && this.props.match.params.view !== "review")){
                    return s.CourseChapter.map(c => {
                        return c.ChapterVideo.map(v => {
                            tests.push(v);
                        })
                        
                    })
                }
                return true;
            })
        }

        let cuReview = this.props.courseUser[0].currentSubject === rsid && isReview;

        return tests.map((t, i) => {

            let completed = this.props.userLectureTests.filter(p => p.chapterVideoId === t.id && p.completed).length > 0;
            let currentChapter = null;
            let currentChapterPart = {};
            if(this.props.testCourse.CourseSubject){
            this.props.testCourse.CourseSubject.map(s => {
                s.CourseChapter.map(c => {
                    if(c.id === cu.currentChapter){
                        currentChapter = c;
                        if(c.type !== "test"){
                            c.ChapterVideo.map(v => {
                                if(v.id === cu.currentChapterPart){
                                    currentChapterPart = v;
                                }
                                return true;
                                
                            })
                        }
                    }
                    return true;
                })
                return true;
            })
        }

            
            /*

            if(currentChapterPart) {
                if (completed.length > 0) {
                    videoClass = 'completed-video';
                    iconClass = 'zmdi zmdi-check-circle';
                } else if (currentChapterPart.id === vid.id && current) {
                    iconClass = 'zmdi zmdi-play-circle';
                    videoClass = 'active-video';
                } else {
                    videoClass = 'video-locked';
                }
            }else{
                videoClass = 'completed-video';
                iconClass = 'zmdi zmdi-check-circle';
            }
            
            */
            
           let options = ['0', 'A', 'B', 'C', 'D', 'E'];
            
            return (
                <div key={i} className="my-tests-row-wrap">
                    {t ?
                    <div className="my-tests-row">
                        <div className="my-tests-left">
                            <div className="test-column-test-name">
                                {t.title || t.name}
                            </div>
                            <div className="test-column-subject">
                                {this.props.testCourse.CourseSubject ? 
                                    this.props.testCourse.CourseSubject.filter(s => s.id === t.courseSubjectId).length > 0 ?
                                        this.props.testCourse.CourseSubject.filter(s => s.id === t.courseSubjectId)[0].name
                                    : this.props.testCourse.CourseSubject.filter(s => s.id === t.subjectId).length > 0 ?
                                    this.props.testCourse.CourseSubject.filter(s => s.id === t.subjectId)[0].name
                                : ''
                                : ''}
                            </div>
                            <div className="test-column-test-type">
                                {t.type === 'test' ? 'Test' : 'Chapter Quiz'}
                            </div>
                        </div>
                        <div className="my-tests-right">
                            {cuReview ?
                            this.props.userLectureTests.filter(ut => ut.chapterVideoId === t.id && ut.completed).length > 0 ?
                                    t.type === 'test' ?

                                        <Link className="btn btn-primary" to={`/subject-test/${t.id}`}>Retake Test</Link>
                                    :
                                        <Link className="btn btn-primary" to={`/video/item/${t.id}`}>Review</Link>

                                    :
                            
                                    t.type === 'test' ?

                                        <Link className="btn btn-primary" to={`/subject-test/${t.id}`}>Start</Link>
                                    :
                                        <Link className="btn btn-primary" to={`/video/item/${t.id}`}>Start</Link>

                                    
                            : completed || currentChapter ?
                                completed || currentChapter.id === t.id || cu.courseCompleted ?
                            
                                this.props.userLectureTests.filter(ut => ut.chapterVideoId === t.id && ut.completed).length > 0 ?
                                    t.type === 'test' ?

                                            <Link className="btn btn-primary" to={`/subject-test/${t.id}`}>Retake Test</Link>
                                        :
                                            <Link className="btn btn-primary" to={`/video/item/${t.id}`}>Review</Link>

                                        :
                                    
                                        <Link className="btn btn-primary" to={`/video/item/${t.id}`}>Start</Link>
                                    :
                                    <a href="#" className="btn btn-default"><i className="zmdi zmdi-lock"></i> Locked</a>
                                :
                                     <a href="#" className="btn btn-default"><i className="zmdi zmdi-lock"></i> Locked</a>
                                
                            }
                            
                            {completed &&
                            <a className="btn btn-default" onClick={e => {
                                e.preventDefault();
                                let {expanded} = this.state;
                                if(expanded.indexOf(t.id) > -1){
                                    expanded.splice(expanded.indexOf(t.id), 1);
                                }else{
                                    expanded.push(t.id);
                                }
                                
                                this.setState({expanded});
                            }} href="#">{this.state.expanded.indexOf(t.id) > -1 ? 'Hide' : 'Details'}</a>
                            }
                        </div>
                    </div>
                    : 
                    <div>
                            {t.ChapterVideo.length > 0 &&
                                t.ChapterVideo.map((v, i) => {
                                    let completedPart = this.props.userLectureTests.filter(p => p.chapterVideoId === v.id).length > 0;
                                    
                                    return (
                                       <div className="my-tests-row" key={i}>
                                            <div className="my-tests-left">
                                                
                                                <div className="test-column-test-name">
                                                    {v.VideoFile[0].thumbnail ?
                                                    <div className="video-thumbnail" style={{background: "url('" + api.makeFileURL(v.VideoFile[0].thumbnail, this.props.user.id) + "')"}}></div>
                                                    :
                                                    <div className="video-thumbnail" style={{background: "url('" + placeholder + "')"}}></div>
                                                    }
                                                    <div className="video-thumbnail-title">{v.title}</div>
                                                </div>
                                                <div className="test-column-subject">
                                                    {this.props.testCourse.CourseSubject ? this.props.testCourse.CourseSubject.filter(s => s.id === t.courseSubjectId)[0].name : ''}
                                                </div>
                                                <div className="test-column-test-type">
                                                    Video
                                                </div>
                                            </div>
                                            <div className="my-tests-right">
                                                {this.props.userLectureTests.filter(ut => ut.chapterVideoId === t.id && ut.correctPercent).length > 0 ?
                                                    <a className="btn btn-primary" href="#">Watch</a>
                                                    :
                                                    
                                                    completedPart || currentChapterPart.id === v.id ?
                                                    <Link className="btn btn-primary" to={`/video/item/${v.id}`}>Watch</Link>
                                                    :
                                                    <a href="#" className="btn btn-default"><i className="zmdi zmdi-lock"></i> Locked</a>
                                                    
                                                }
                                                
                                            </div>
                                        </div>
                                    )       
                                })
                            }
                        
                        
                    </div>
                    
                    }
                    <div className={`my-test-row-attempts animated ${this.state.expanded.indexOf(t.id) > -1 ? 'slideInDown show' : 'slideOutUp hidden'}`}>
                        {this.props.userLectureTests.filter(ut => ut.chapterVideoId === t.id).map((u, ui) => {
                            let f = moment.duration(u.finishedAt);
                            if(u){
                            return (
                                <div className="my-tests-row-details-wrapper" id="TestID1" key={ui}>
                                    <div className="my-tests-row-details-wrap">
                                        <div className="my-tests-row-details-item">
                                            {u.passed || u.quiz > 80 ?
                                            <i className="zmdi zmdi-check text-green"></i>
                                            :
                                            <i className="zmdi zmdi-close text-danger"></i>
                                            }
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Attempt</p>
                                            <h4>{ui + 1}</h4>
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Test Type</p>
                                            {u.type === 'test' ?
                                                <h4>{u.testMode}</h4>
                                            : 
                                                <h4>Quiz</h4>
                                            }
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Time Taken</p>
                                            {u.completedIn ?
                                            <h4>{u.completedIn > 0 ?
                                                moment.utc(moment.duration((u.completedIn) * 1000).as('milliseconds')).format('HH:mm:ss')
                                            : '00:00'}</h4>
                                            :
                                            <h4>N/A</h4>
                                            }
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Test Score</p>
                                            <h4 className={`${u.correctPercent >= 80 || u.quiz > 80 ? 'text-success' : 'text-danger'}`}>{u.correctPercent || u.quiz}%</h4>
                                        </div>
                                    </div>
                                    <div>
                                        {u.type === 'test' ?
                                        <a className="btn btn-default" href={"#TestResultModal"} onClick={e => this.props.enrichTest(u.id)} data-toggle="modal">Overview</a>
                                        :
                                        <a className="btn btn-default" href={"#QuizResultModal"} onClick={e => this.props.enrichQuiz(u.id)} data-toggle="modal">Overview</a>
                                        }
                                        
                                    </div>
                                </div>
                            )  
                            }else{
                                
                            return (
                                <div className="my-tests-row-details-wrapper" id="TestID1">
                                    <div className="my-tests-row-details-wrap">
                                        <div className="my-tests-row-details-item">
                                            <i className="zmdi zmdi-check-circle text-green"></i>
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Attempt</p>
                                            <h4>{ui + 1}</h4>
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Test Type</p>
                                            <h4>{u.testMode}</h4>
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Time Taken</p>
                                            <h4>In Progress</h4>
                                        </div>
                                        <div className="my-tests-row-details-item">
                                            <p>Test Score</p>
                                            <h4>N/A</h4>
                                        </div>
                                    </div>
                                    <div>
                                        
                                    </div>
                                </div>
                            )  
                            }
                        })
                        }
                        
                        
                                                    
                                                    
                        
                    </div>
                </div>    
            )
        })
    }
    
    renderConfigHighchart = (statisticDiagram) => {

        let self = this;
        let {chartType, chartX} = this.state;


        return (
            {
                chart: {
                    height: 300,
                    type: 'spline',
        
        
                    backgroundColor: {
                        linearGradient: { x1: 0, y1: 0, x2: 1, y2: 1 },
                        stops: [
                            [0, '#333'],
                            [1, '#333']
                        ]
                    }
                    
                },
                title: false,
                subtitle: false,
                colors: ['#fff'],
                xAxis: [{
                    categories: this.state.chartX,
                    crosshair: true
                }],
                yAxis: [{ // Secondary yAxis
                    gridLineColor: '#3a3a3a',
                    title: {
                        text: 'Score',
                        style: {
                            color: '#fff'
                        }
                    },
                    labels: {
                        format: '{value}',
                        style: {
                            color: '#fff'
                        }
                    },
                    min: 0,
                    max: 100,

                }],
                tooltip: {
                    shared: true
                },
                legend: false,
                series: statisticDiagram
            }
        )
    
            
        
        
    };
    
    buildChart = (mode) => {
        let data = [];
        let chartX = [];
        data = [{name: 'Score', data: []}];
        let cu = this.props.courseUser[0];
        this.props.userLectureTests.filter(ul => ul.type === 'test').map((t, i) => {
            chartX.push(i + 1);
            let lecture = {name: t.title, y: t.correctPercent};
            data[0].data.push(lecture);
        })
        
        this.setState({chart: data, chartX});
    }

    render(){
        let options = ['0', 'A', 'B', 'C', 'D', 'E'];
        return (
            <div className="content-wrapper">
                {this.renderHeader()}
                {this.renderTabs()}
            
                <section className="content">
                
                
                <div style={{background: "#333"}}>
                    <div className="flex flex-justify-content-space-between sp-20">
                        <h3 className="sm-top0 font-20 text-white">Score Overview</h3>
                        <div>
                            <a className="btn btn-default" href="#">30 days</a>
                            <a className="btn btn-default" href="#">90 days</a>
                            <a className="btn btn-default" href="#">1 Year</a>
                            <a className="btn btn-default" href="#">All Time</a>
                        </div>
                    </div>
                    <div className="sm-bottom20" id="chart_1" data-highcharts-chart="0">
                        {this.state.chart.length > 0 &&
                         <ReactHighcharts
                                config={this.renderConfigHighchart(this.state.chart)}
                                isPureConfig={true}
                                neverReflow={true}
                                ref="chart"
                            />
                        }
                    
                    </div>
                    </div>
                    <div className="my-tests-wrap">
                        <div className="my-tests-head my-tests-row-wrap">
                            <div className="my-tests-row">
                                <div className="my-tests-left">
                                    <div className="test-column-test-name">
                                        Test Name
                                    </div>
                                    <div className="test-column-subject">
                                        Subject
                                    </div>
                                    <div className="test-column-test-type">
                                        Test Type
                                    </div>
                                </div>
                                <div className="my-tests-right">
    
                                </div>
                            </div>
    
                        </div>
                        {this.renderTests()}
                        
                    </div>
                </section>
                <div tabIndex="-1" className="modal fade" id="TestResultModal" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                <Scrollbars style={{ height: "calc(100vh - 100px)" }}>
                    <div className="modal-content light-text test-result-modal">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Test Summary</h4>
                        </div>
                        <div className="modal-body">
                        {this.props.testDetails ? 
                            this.props.testDetails.id ?
                        <div className="FinalAnswerToMCQ sp-20">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <p className="font-30 font-300 sm-bottom30">Test Results</p>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <p className="no-margin">Correct</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.props.testDetails.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                    <p className="no-margin">Incorrect</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.props.testDetails.totalQuestions - this.props.testDetails.correctAnswers}</p>
                                </div>
                                {this.props.testDetails.timeLimit ?
                                    <div className="col-sm-3">
                                        <p className="no-margin">Time Taken</p>
                                        <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">
                                            {this.props.testDetails.timeLimit - this.props.testDetails.completedIn > 0 ?
                                                moment.utc(moment.duration((this.props.testDetails.completedIn) * 1000).as('milliseconds')).format('HH:mm:ss')
                                            : '00:00'}
                                        </p>
                                    </div>
                                :
                                <div className="col-sm-3">
                                </div>
                                }


                                <div className="col-sm-3">
                                    <div className="video-question-summary">
                                        <PieChart
                                            style={{width: 80, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#555'},
                                                {value: this.props.testDetails.correctPercent, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.props.testDetails.correctPercent}%</p>
                                    </div>

                                    </div>
                            </div>
                            <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                                {this.props.testDetails.correctPercent >= 80 ?
                                <span className="text-success"> {this.props.testDetails.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                                    :
                                    <span className="text-danger"> Failed</span>}

                                    </p>

                            <table className="table">
                                <tbody>
                                <tr>
                                    <th className="text-center" style={{width: 50}}>Result</th>
                                    <th className="text-center" style={{width: 100}}>Answered</th>
                                    <th className="text-left">Question</th>
                                    <th className="text-center" style={{width: 122}}>Time Taken</th>
                                </tr>
                                {
                                    this.props.testDetails.sections &&
                                    this.props.testDetails.sections.map((section, si) => {
                                        
                     
                                            return section.questions.map((a, i) => {
                                                let seconds = 0;
                                                let timer = "";
                                                if(a.time){
                                                    seconds = parseInt(a.time % 60);
                                                    timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                                        : parseInt(a.time / 60) + ":" + seconds.toString();
                                                }
                                                return (
                                                    <tr key={i}>
                                                        <td className="text-center"><i className={(a.userAnswer === a.correctOption) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                                        <td className="text-center">
                                                            {a.userAnswer}
                                                        </td>
                                                        <td className="text-left">
                                                            <p className="font-14" data-toggle="collapse" data-target={`#LECTURETEST-${si}-${i}`} aria-expanded="false" aria-controls={`#LECTURETEST-${si}-${i}`} dangerouslySetInnerHTML={{__html: a.question}}></p>
                                                            <div className="modalQuizeAnswersOptions collapse" id={`LECTURETEST-${si}-${i}`}>
                                                                            {options.filter(o => o !== '0').map((o, oi) => {
                                                                                if(o === "E"){
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }else{
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.userAnswer === o ? a.userAnswer === a.correctOption ? 'bg-success' : 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html: a["option" + o]}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                                
                                                                            })}
                                                                            
                                                                        </div>
                                                        </td>
                                                        <td className="text-center">{timer}</td>
                                                    </tr>
                                                )
                                            })
                                        

                                })}
                                </tbody>
                            </table>
                        </div>
                        : null
                        : null }
                        </div>

                    </div>
                    </Scrollbars>
                </div>
                    
                </div>

                {this.renderQuizModal()}
            </div>
            
            )
    }
    
}

MyTests.propTypes = {
    user: PropTypes.shape({
        user: PropTypes.shape({
            email: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired
        })
    }),
    courseUser: PropTypes.arrayOf(PropTypes.shape({
     id: PropTypes.string.isRequired
   })).isRequired
};

export default MyTests;


// WEBPACK FOOTER //
// ./src/components/UserCourse/MyTests.js